import {createFeatureSelector, createSelector} from "@ngrx/store";
import {Revisione53State, STATE_KEY_REVISIONE53} from "../revisione53.reducers";

const state = createFeatureSelector<Revisione53State>(STATE_KEY_REVISIONE53)

export abstract class Revisione53DatiBusinessSelectors {

  static getDatiBusiness = createSelector(
    state,
    state => state.datiBusiness
  )

  static getProvince = createSelector(
    state,
    state => state.datiBusiness?.provincia
  )

  static getComuni = (idProvincia: string) => createSelector(
    state,
    state => state.datiBusiness?.comune?.filter(comune => comune.id_provincia === idProvincia)
  )

  static getComune = (codComune: string) => createSelector(
    state,
    state => state.datiBusiness?.comune?.find(comune => comune.cod_comune === codComune)
  )

  static getProvincia = (codProvincia : string) => createSelector(
    state,
    state => state.datiBusiness?.provincia?.find(provincia => provincia.Id_provincia === codProvincia)
  )

  static getCodISTAT = (codAttiv : string) => createSelector(
    state,
    state => state.datiBusiness?.attivita?.find(attivita => attivita.cod_ISTAT?.trim() === codAttiv?.trim())
  )

  static getCentrale = createSelector(
    state,
    state => state.datiBusiness?.centrale
  )

  static getCentraleSpec = (idCluster : string) => createSelector(
    state,
    state => state.datiBusiness?.centrale?.find(centrale => centrale.Id_cluster === idCluster)
  )

  static getSezioneAlboNazEntiCoop = createSelector(
    state,
    state => state.datiBusiness?.sezionealbonazenticoop
  )

  static getSezioneAlboNazEntiCoopSpec = (idAlbo: string) => createSelector(
    state,
    state => state.datiBusiness?.sezionealbonazenticoop?.find(sez => sez.Id_tipoSezione === idAlbo)
  )

  static getEsitoCertificazioneBilancio = createSelector(
    state,
    state => state.datiBusiness?.esitocertificazione
  )

  static getSocietaRevisioni = createSelector(
    state,
    state => state.datiBusiness?.societarevisione
  )

  static getSocietaRevisione = (id_societa : string) => createSelector(
    state,
    state => state.datiBusiness?.societarevisione?.find(societa => societa.id_societaDiRevisione === id_societa)
  )

  static getRegimeDerogatorio = createSelector(
    state,
    state => state.datiBusiness?.regimederogatorioallaprevalenza
  )

  static getAmmUnCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_AllAmmUnCarica
  )

  static getAllConsAmmCaricaSpec = (carica: string) => createSelector(
    state,
    state => state.datiBusiness?.caricasociale_AllConsAmmCarica?.find(caricaConsAmm => caricaConsAmm.id_carica === carica)
  )

  static getAllConsAmmCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_AllConsAmmCarica
  )

  static getAllCollSindCaricaSpec = (carica: string) => createSelector(
    state,
    state => state.datiBusiness?.caricasociale_AllCollSindCarica?.find(collCarica => collCarica.id_carica === carica)
  )

  static getAllCollSindCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_AllCollSindCarica
  )

  static getSpmComitGestCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_SpmComitGestCarica
  )

  static getSpdConsSorvCaricaSpec = (carica: string) => createSelector(
    state,
    state => state.datiBusiness?.caricasociale_SpdConsSorvCarica?.find(caricaSorv => caricaSorv.id_carica === carica)
  )

  static getSpdConsSorvCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_SpdConsSorvCarica
  )

  static getSpdConsGestCaricaSpec = (carica: string) => createSelector(
    state,
    state => state.datiBusiness?.caricasociale_SpdConsGestCarica?.find(caricaGest => caricaGest.id_carica === carica)
  )

  static getSpdConsGestCarica = createSelector(
    state,
    state => state.datiBusiness?.caricasociale_SpdConsGestCarica
  )

  static getTassoInteressiLegali = createSelector(
    state,
    state => state.datiBusiness?.tassointeressilegali
  )

  static getFasciaPerContributoRevisione = createSelector(
    state,
    state => state.datiBusiness?.fasciapercontributorevisione
  )

  static getSanzionePerEevisione = createSelector(
    state,
    state => state.datiBusiness?.sanzioneperrevisione
  )

  static getSottocategoriaEnteSociale = createSelector(
    state,
    state => state.datiBusiness?.sottocategoriaentesociale
  )

  static getSottocategoriaEnteSocialeSpec = (idSottocategoria : string) => createSelector(
    state,
    state => state.datiBusiness?.sottocategoriaentesociale?.find(sottocategoria => sottocategoria.id_sottocategoria === idSottocategoria)
  )

  static getModoAssociazione = createSelector(
    state,
    state => state.revisione?.dati?.my_Verbale?.my_SezioneI__Rilevazione?.my_SchedaCoopTrasporto?.my_ModoDiAssociazione
  )

  static getContratti = createSelector(
    state,
    state => state.datiBusiness?.contratto
  )

}
